export default __webpack_public_path__ + "static/media/document-protection.c958b06b.png";